import { render } from "./VMultiAutocompleteButton.vue?vue&type=template&id=5e499fb6"
import script from "./VMultiAutocompleteButton.vue?vue&type=script&lang=js"
export * from "./VMultiAutocompleteButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__